export const jsonData = {
    statements: {
        data: [
            {
                id: "Happy",
                title: "I feel in good spirits",
                no: "1 of 5",
                checked: 0,
                value: ''
            },
            {
                id: "Relaxed",
                title: "I feel calm and relaxed",
                no: "2 of 5",
                checked: 0,
                value: ''
            },
            {
                id: "Active",
                title: "I feel active and energetic",
                no: "3 of 5",
                checked: 0,
                value: ''
            },
            {
                id: "Fresh and rested",
                title: "I woke up fresh and rested",
                no: "4 of 5",
                checked: 0,
                value: ''
            },
            {
                id: "Day of interests",
                title: "My day is full of things that interest me",
                no: "5 of 5",
                checked: 0,
                value: ''
            },
        ]
    }

}

export default jsonData;